import ProductEventList from "./ProductEventList";
import ProductEventCreate from "./ProductEventCreate";
import ProductEventEdit from "./ProductEventEdit";
import ProductEventShow from "./ProductEventShow";
import EventIcon from "@mui/icons-material/Event";

const productEvents = {
  list: ProductEventList,
  create: ProductEventCreate,
  edit: ProductEventEdit,
  show: ProductEventShow,
  icon: EventIcon,
};

export default productEvents;
